var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.75H16.5C17.7426 2.75 18.75 3.75736 18.75 5V14.8887C18.75 15.105 18.6566 15.3107 18.4939 15.4531L14.3667 19.0644C14.23 19.1841 14.0545 19.25 13.8728 19.25H4.5C3.25736 19.25 2.25 18.2426 2.25 17V5C2.25 3.75736 3.25736 2.75 4.5 2.75ZM4.5 21.5C2.01472 21.5 0 19.4853 0 17V5C0 2.51472 2.01472 0.5 4.5 0.5H16.5C18.9853 0.5 21 2.51472 21 5V14.8887C21 15.7538 20.6266 16.5768 19.9755 17.1464L15.8483 20.7577C15.3014 21.2362 14.5995 21.5 13.8728 21.5H4.5ZM5.25 8.75C5.25 8.12868 5.75368 7.625 6.375 7.625H14.625C15.2463 7.625 15.75 8.12868 15.75 8.75C15.75 9.37132 15.2463 9.875 14.625 9.875H6.375C5.75368 9.875 5.25 9.37132 5.25 8.75ZM6.375 12.125C5.75368 12.125 5.25 12.6287 5.25 13.25C5.25 13.8713 5.75368 14.375 6.375 14.375H11.625C12.2463 14.375 12.75 13.8713 12.75 13.25C12.75 12.6287 12.2463 12.125 11.625 12.125H6.375Z",
    fill: "#0C0589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkUnion);
export default __webpack_public_path__ + "static/media/darkUnion.89646fb72b68d057779ab408628dbf85.svg";
export { ForwardRef as ReactComponent };